module.exports = __webpack_public_path__ + "static/media/learn-icon-default.f80e367b.svg";